/**
 * PubNub message `type` for venue-scoped TL Pro channels (`TL_PRO_VENUE_${venueId}`).
 * Values are wire-stable; `SOFT_REFERSH` remains for backward compatibility.
 */
export enum PubSubEvent {
  SUBSCRIPTION_UPDATED = 'SUBSCRIPTION_UPDATED',
  POS_UPDATED = 'POS_UPDATED',
  LOCKED = 'LOCKED',
  UNLOCKED = 'UNLOCKED',
  SELLING_APPROVED_ENABLED = 'SELLING_APPROVED_ENABLED',
  HARD_REFRESH = 'HARD_REFRESH',
  SOFT_REFRESH = 'SOFT_REFRESH',
  /** @deprecated Historical typo; use SOFT_REFRESH. */
  SOFT_REFERSH = 'SOFT_REFERSH',
  PRODUCT_UPDATES = 'PRODUCT_UPDATES',
  VENUE_UPDATED = 'VENUE_UPDATED',
}
